<div class="submit-container"
     data-testid="bq9-container-submission">
  <div class="submit-confirmation"
       data-testid="bq9-container-submit-confirmation">
    <div class="message-content">
      @if (isOnline) {
        @if (!submissionFinished) {
          <div class="spinning"
               data-testid="bq9-container-uploading">
            <p-progress-spinner ariaLabel="Uploading your work" />
          </div>
          <a>Uploading your work</a>
        }
        @else if (maxTimeoutElapsed) {
          <img class="icon"
               src="assets/icons/sync-info.svg"
               alt="upload in progress"
               data-testid="bq9-img-in-progress-icon" />
          <p-tag severity="info"
                 value="Upload in Progress"
                 [rounded]="true"
                 data-testid="bq9-badge-in-progress" />
          <div class="confirmation-message"
               data-testid="bq9-text-in-progress">
            <div>
              Your work is currently uploading.
            </div>
            <div>
              To ensure the homeowner receives their email, please <strong>keep this app open</strong> until the upload is 100% complete.
            </div>
          </div>
          <img src="assets/icons/divider.svg"
               alt="divider"
               class="divider"
               data-testid="bq9-img-divider-in-progress" />
          <p-button label="Go to schedule"
                    styleClass="bqa-primary-btn"
                    (click)="clickOnDone()"
                    data-testid="bq9-btn-go-to-schedule" />
        }
        @else {
          <img class="icon"
               src="assets/icons/check-circle-outline.svg"
               alt="Looking great!"
               data-testid="bq9-img-complete-icon" />
          <p-tag severity="success"
                 value="Complete"
                 [rounded]="true"
                 data-testid="bq9-badge-complete" />
          <div class="confirmation-message"
               data-testid="bq9-text-complete">
            <div>
              Your work has been <strong>successfully uploaded</strong>.
            </div>
            <div>
              All documents are signed and shared, and a copy has been emailed to the homeowner
            </div>
          </div>
          <img src="assets/icons/divider.svg"
               alt="divider"
               class="divider"
               data-testid="bq9-img-divider-complete" />
          <p-button label="Done"
                    styleClass="bqa-primary-btn"
                    (click)="clickOnDone()"
                    data-testid="bq9-btn-done" />
        }
      }
      @else {
        <img class="icon"
             src="assets/icons/sync-warn.svg"
             alt="upload pending"
             data-testid="bq9-img-pending-icon" />
        <p-tag severity="warn"
               value="Upload Pending"
               [rounded]="true"
               data-testid="bq9-badge-pending" />
        <div class="confirmation-message"
             data-testid="bq9-text-pending">
          <div>
            Your work is <strong>saved to this device</strong>, but the upload is paused because you are currently offline.
          </div>
          <div>
            The homeowner will be emailed once you reconnect and <strong>keep this app open</strong>.
          </div>
        </div>
        <img src="assets/icons/divider.svg"
             alt="divider"
             class="divider"
             data-testid="bq9-img-divider-pending" />
        <p-button label="Go to schedule"
                  styleClass="bqa-primary-btn"
                  (click)="clickOnDone()"
                  data-testid="bq9-btn-go-to-schedule" />
      }
    </div>
  </div>
</div>
